import { Injectable } from '@angular/core';
import { select } from '@ngneat/elf';
import { Observable } from 'rxjs';
import { AppStore } from './app.store';

@Injectable({ providedIn: 'root' })
export class AppQuery {
  constructor(readonly appStore: AppStore) {}

  readonly loading$: Observable<boolean> = this.appStore.pipe(select((state) => state.loading));

  isLoading() {
    return this.appStore.getValue().loading;
  }
}
